/**
 * Swaps a client's key for its company name in text the backend recorded.
 *
 * Done here rather than when the step is written: the screen already has the
 * company names loaded, and a name that changes later should read as the name
 * it is now, while the stored record keeps the key it was given.
 *
 * The key stays when no name is known — a raw key is better than a wrong one.
 */
export const withCompanyName = (
  text: string | undefined,
  clientPublicKey: string | undefined,
  companyName: string | undefined
): string | undefined => {
  if (!text || !clientPublicKey || !companyName) {
    return text
  }
  return text.split(clientPublicKey).join(companyName)
}
